import { render, staticRenderFns } from "./HeaderTaskDetail.vue?vue&type=template&id=64ab9f32&scoped=true"
import script from "./HeaderTaskDetail.vue?vue&type=script&lang=js"
export * from "./HeaderTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab9f32",
  null
  
)

export default component.exports